<script lang="ts">
  import { t } from '../i18n/index';
  import FeedbackForm from './FeedbackForm.svelte';

  // Footer enthält jetzt NUR noch das Feedback-Form + optional die
  // Barrierefreiheitserklärung (wenn vom Site-Owner hinterlegt). Der
  // „Accessify Dashboard"-Link wurde entfernt — der ist nur fürs Admin-
  // Publikum interessant, nicht für die Site-Besucher die das Widget
  // tatsächlich benutzen.
  let {
    lang = 'en',
    statementUrl,
    siteKey,
    apiBase,
    allowHide = false,
    onhide,
  }: {
    lang?: string;
    statementUrl?: string;
    siteKey?: string;
    apiBase?: string;
    allowHide?: boolean;
    onhide?: () => void;
    onclose?: () => void;
  } = $props();

  // „Ausblenden" blendet NICHT sofort aus — zuerst eine kurze Erklärung +
  // Bestätigung (das Widget verschwindet nur für den Besucher; zurück nur über
  // Website-Daten löschen). Erst „Ausblenden" im Confirm dispatcht den Hide.
  let confirming = $state(false);

  function confirmHide() {
    confirming = false;
    onhide?.();
  }
</script>

<div class="accessify-footer">
  <!-- Feedback + „Widget ausblenden" sitzen nebeneinander in EINER Aktionszeile.
       Klappt das Feedback-Form auf, nimmt es per :has()-Regel die volle Breite
       und der Ausblenden-Button rutscht in die nächste Zeile. -->
  <div class="accessify-footer-actions">
    <FeedbackForm {lang} {siteKey} {apiBase} />
    {#if allowHide && !confirming}
      <!-- EyeAble-style „Widget ausblenden": öffnet zuerst die Bestätigung
           unten (accessify-hide-confirm), blendet erst nach „Ausblenden" aus. -->
      <button
        type="button"
        class="accessify-hide-btn"
        onclick={() => { confirming = true; }}
        aria-label={t('widget.hide', lang)}
        title={t('widget.hideHint', lang)}
      >
        <span class="accessify-hide-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/>
            <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/>
            <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/>
            <path d="M2 2l20 20"/>
          </svg>
        </span>
        {t('widget.hideShort', lang)}
      </button>
    {/if}
  </div>

  {#if allowHide && confirming}
    <div class="accessify-hide-confirm" role="group" aria-label={t('widget.hideConfirmTitle', lang)}>
      <div class="accessify-hide-confirm-title">{t('widget.hideConfirmTitle', lang)}</div>
      <div class="accessify-hide-confirm-body">{t('widget.hideConfirmBody', lang)}</div>
      <div class="accessify-hide-confirm-actions">
        <button type="button" class="accessify-hide-confirm-btn accessify-hide-confirm-btn--secondary" onclick={() => { confirming = false; }}>
          {t('widget.cancel', lang)}
        </button>
        <button type="button" class="accessify-hide-confirm-btn accessify-hide-confirm-btn--primary" onclick={confirmHide}>
          {t('widget.hideShort', lang)}
        </button>
      </div>
    </div>
  {/if}

  {#if statementUrl}
    <div class="accessify-footer-links">
      <a href={statementUrl} target="_blank" rel="noopener noreferrer">
        {t('widget.statement', lang)}
      </a>
    </div>
  {/if}

  <!-- Ehrliche Disclaimer-Zeile, immer sichtbar: das Widget verbessert sofort,
       ersetzt aber keine echte barrierefreie Umsetzung. Das ist unser
       Burggraben (Ehrlichkeit), nicht Kleingedrucktes zum Verstecken. -->
  <div class="accessify-footer-note">{t('footer.disclaimer', lang)}</div>
</div>
